/* 孫吳傳・第 8 章：宣城（196 年前後）
 * 孫權駐宣城，營地沒有築圍籬，四周是山林。山賊從四條山路同時摸進來。夜裡，視野很短。 */
export const CAMP = [3200, 2400];
export const PATHS = [[3200, 400], [6100, 2400], [3200, 4500], [300, 2400]]; // 北、東、南、西四條山路的入口
export default {
  id: 'xuancheng', name: '宣城', W: 6400, H: 4800, seed: 196,
  bases: [CAMP, [6000, 600]],
  roads: [
    { pts: [CAMP, [3300, 1500], [3200, 400]], w: 110 }, { pts: [CAMP, [4600, 2300], [6100, 2400]], w: 110 },
    { pts: [CAMP, [3100, 3400], [3200, 4500]], w: 110 }, { pts: [CAMP, [1800, 2500], [300, 2400]], w: 110 },
  ],
  rocks: [[1500, 1200, 420, 220], [4900, 1200, 420, 220], [1500, 3700, 420, 220], [4900, 3700, 420, 220]],
  woods: 0.6,
  sight: 0.55,
  clearings: [[CAMP[0], CAMP[1], 650]],
  tents: [{ x: CAMP[0], y: CAMP[1], n: 6, r: 360, chief: true, col: '#b8433a', flag: '孫' }],
  grass: [[3600, 1300, 200, 90], [4500, 2700, 200, 90], [2700, 3400, 200, 90], [1900, 2100, 200, 90]],
};
